const configs = require("../configs.json");

export const networks = [137, 56];

export const ChainId = {
    POLYGON: 137,
    BNB: 56,
};

export const chainConfigs = {
    Polygon: {
        chainId: `0x${Number(137).toString(16)}`, // A 0x-prefixed hexadecimal string
        chainName: "Polygon",
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC", // 2-6 characters long
            decimals: 18,
        },
        rpcUrls: [
            "https://polygon-rpc.com/",
            "https://rpc-mainnet.matic.network",
            "https://matic-mainnet.chainstacklabs.com",
            "https://rpc-mainnet.maticvigil.com",
            "https://rpc-mainnet.matic.quiknode.pro",
            "https://matic-mainnet-full-rpc.bwarelabs.com",
        ],
        blockExplorerUrls: ["https://polygonscan.com"],
    },

    BNB: {
        chainId: `0x${Number(56).toString(16)}`, // A 0x-prefixed hexadecimal string
        chainName: "BNB Smart Chain",
        nativeCurrency: {
            name: "BNB",
            symbol: "BNB", // 2-6 characters long
            decimals: 8,
        },
        rpcUrls: [
            "https://binance.llamarpc.com",
            "https://bsc-dataseed.bnbchain.org",
            "https://bsc-dataseed1.defibit.io",
            "https://bsc-dataseed1.ninicoin.io",
            "https://bsc-dataseed2.defibit.io",
            "https://1rpc.io/bnb",
        ],
        blockExplorerUrls: ["https://bscscan.com"],
    },
};

export const routerAddress = new Map();

export const stackAddress = new Map();

export const withdrawAddress = new Map();

export const nftSharingAddress = new Map()

export const investContracts = new Map()

for (const [key, value] of Object.entries(configs.chains)) {
    stackAddress.set(ChainId[key], value.stakeAddress);
    routerAddress.set(ChainId[key], value.routerAddress);
    withdrawAddress.set(ChainId[key], value.withdrawAddress);
    nftSharingAddress.set(ChainId[key], value.nftSharingAddress);
    investContracts.set(ChainId[key], value.investContracts);
}